import SuccessfulRegisterIcon from "@/assets/icons/successful-register.svg?react";
import { Button } from "@/components/ui/button";
import { ArrowRight2 } from "iconsax-react";
import { useNavigate } from "react-router-dom";

const SuccessfulRegister = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/");
  };

  return (
    <div className="my-12 flex flex-col items-center">
      <SuccessfulRegisterIcon />
      <p className="mb-3 mt-6 max-w-[280px] text-center text-sm">
        Has completado correctamente el registro de tu empresa en la plataforma
        EGS. Revisa tu correo para acceder y adjuntar los documentos requeridos
        para la nueva edición.
      </p>
      <p className="mb-9 mt-5 px-10 text-center text-sm font-semibold">
        ¡Gracias por tu inscripción!
      </p>
      <Button onClick={handleClick}>
        Ingresar
        <ArrowRight2 size="22" color="white" />
      </Button>
    </div>
  );
};

export default SuccessfulRegister;
